import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { CheckBox, CircleIcon, FlexColumn, Table } from '@ubeya/shared-web/components';
import { ReactComponent as DocumentIcon } from '@ubeya/shared-web/assets/order.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexColumn)`
  flex: 1;
  padding: 31px 50px;
  overflow: auto;
  .loader {
    z-index: 1;
  }
`;

const Container = styled(FlexColumn)`
  flex: 1;
  min-width: 500px;
`;

const AWR = () => {
  const { t } = useContext(ConfigContext);

  const data = [
    {
      position: 'Warehouse op',
      preRate: '£12.55',
      postRate: '£13.50',
      confirmed: true
    },
    {
      position: 'Delivery',
      preRate: '£14.00',
      postRate: '£15.00',
      confirmed: true
    },
    {
      position: 'Driver',
      preRate: '£11.65',
      postRate: '£13.00',
      confirmed: false
    }
  ];

  const columns = useMemo(
    () => [
      {
        Header: t('position'),
        dataKey: 'position',
        maxWidth: 350
      },
      {
        Header: 'Pre rate',
        dataKey: 'preRate'
      },
      {
        Header: 'Post rate',
        dataKey: 'postRate'
      },
      {
        Header: 'Document',
        Cell: () => <CircleIcon icon={DocumentIcon} backgroundColor="grey2" />
      },
      {
        Header: 'Confirmed With Client',
        Cell: ({ rowData: { confirmed } }) => <CheckBox name="publish-to-non-booked" value={confirmed} label="" />
      }
    ],
    [t]
  );

  return (
    <Wrapper>
      <Container>
        <Table columns={columns} data={data} shadow={false} />
      </Container>
    </Wrapper>
  );
};

export default React.memo(AWR);
